import { render, staticRenderFns } from "./jurnal.vue?vue&type=template&id=871a87aa&scoped=true"
import script from "./jurnal.vue?vue&type=script&lang=js"
export * from "./jurnal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871a87aa",
  null
  
)

export default component.exports